"use strict";

exports.__esModule = true;
// keycodes for keyboard events.
var TAB = exports.TAB = 9;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var UP = exports.UP = 38;
var DOWN = exports.DOWN = 40;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y-select/lib/lib/keycodes.js
// module id = 1493
// module chunks = 19